import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../lib/AuthContext'

export default function PaginaNotifiche({ onChiudi, onNavigate }) {
  const { profilo } = useAuth()
  const [notifiche, setNotifiche] = useState([])
  const [caricamento, setCaricamento] = useState(true)
  const [rispondendo, setRispondendo] = useState(null)
  const [messaggioAperto, setMessaggioAperto] = useState(null) // notifica messaggio aperta in modal

  useEffect(() => { carica() }, [])

  async function carica() {
    const { data } = await supabase
      .from('notifiche')
      .select('*')
      .eq('utente_id', profilo.id)
      .order('creato_il', { ascending: false })
      .limit(50)
    setNotifiche(data || [])
    setCaricamento(false)
    // Segna come lette tutte tranne gli inviti gruppo — quelli richiedono un'azione
    // (accetta/rifiuta) e devono restare "da leggere" finché non si risponde davvero.
    await supabase.from('notifiche').update({ letta: true })
      .eq('utente_id', profilo.id).eq('letta', false).neq('tipo', 'invito_gruppo')
    // Aggiorna badge campanella (TopBar e Home)
    if (window.__topBarAggiorna) window.__topBarAggiorna()
    if (window.__homeBadgeAggiorna) window.__homeBadgeAggiorna()
  }

  async function eliminaTutte() {
    await supabase.from('notifiche').delete().eq('utente_id', profilo.id)
    setNotifiche([])
    if (window.__topBarAggiorna) window.__topBarAggiorna()
  }

  async function rispondiInvito(notifica, risposta) {
    setRispondendo(notifica.id)
    try {
      const dati = JSON.parse(notifica.dati || '{}')
      const { gruppo_id } = dati
      if (risposta === 'accetta') {
        await supabase.from('gruppo_membri')
          .update({ stato: 'attivo' })
          .eq('gruppo_id', gruppo_id)
          .eq('utente_id', profilo.id)
        await supabase.from('notifiche').insert({
          utente_id: dati.coach_id,
          tipo: 'info',
          titolo: '✅ Invito accettato',
          testo: `${profilo.nome} ${profilo.cognome || ''} ha accettato l'invito nel gruppo "${dati.gruppo_nome}".`,
        })
      } else {
        await supabase.from('gruppo_membri')
          .update({ stato: 'rifiutato' })
          .eq('gruppo_id', gruppo_id)
          .eq('utente_id', profilo.id)
        await supabase.from('notifiche').insert({
          utente_id: dati.coach_id,
          tipo: 'info',
          titolo: '❌ Invito rifiutato',
          testo: `${profilo.nome} ${profilo.cognome || ''} ha rifiutato l'invito nel gruppo "${dati.gruppo_nome}".`,
        })
      }
      await supabase.from('notifiche').delete().eq('id', notifica.id)
      setNotifiche(prev => prev.filter(n => n.id !== notifica.id))
    } catch (e) {
      console.error('Errore risposta invito:', e)
    }
    setRispondendo(null)
  }

  const ICONE = {
    sessione: '📅',
    messaggio: '💬',
    abbonamento: '💳',
    regalo: '🎁',
    info: '📢',
    invito_gruppo: '👥',
    richiesta_utente: '📩',
    richiesta_gruppo: '🙋',
    risposta_richiesta: '💬',
    adesione: '📣',
    default: '🔔',
  }

  const COLORI = {
    sessione: { bg: 'rgba(127,214,61,0.12)', border: 'rgba(127,214,61,0.25)' },
    messaggio: { bg: 'rgba(87,184,255,0.12)', border: 'rgba(87,184,255,0.25)' },
    abbonamento: { bg: 'rgba(74,222,128,0.12)', border: 'rgba(74,222,128,0.25)' },
    regalo: { bg: 'rgba(199,125,255,0.12)', border: 'rgba(199,125,255,0.25)' },
    invito_gruppo: { bg: 'rgba(87,184,255,0.12)', border: 'rgba(87,184,255,0.3)' },
    richiesta_utente: { bg: 'rgba(251,191,36,0.12)', border: 'rgba(251,191,36,0.3)' },
    richiesta_gruppo: { bg: 'rgba(127,214,61,0.12)', border: 'rgba(127,214,61,0.3)' },
    risposta_richiesta: { bg: 'rgba(127,214,61,0.12)', border: 'rgba(127,214,61,0.25)' },
    adesione: { bg: 'rgba(255,120,87,0.12)', border: 'rgba(255,120,87,0.3)' },
    default: { bg: 'var(--surface2)', border: 'var(--border)' },
  }

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }} className="fade-in">
      <div className="topbar">
        <button className="back-btn" onClick={onChiudi}>&larr;</button>
        <div style={{ fontFamily: 'Syne', fontWeight: 700 }}>Notifiche</div>
        {notifiche.length > 0 && (
          <button onClick={eliminaTutte} style={{ background: 'none', border: 'none', color: 'var(--muted)', fontSize: 12, cursor: 'pointer' }}>
            Cancella tutte
          </button>
        )}
      </div>

      <div className="scroll-area">
        {caricamento ? (
          <div style={{ textAlign: 'center', color: 'var(--muted)', padding: 40 }}>Caricamento...</div>
        ) : notifiche.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>🔔</div>
            <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 16, marginBottom: 8 }}>Nessuna notifica</div>
            <div style={{ fontSize: 13, color: 'var(--muted)' }}>Le notifiche di sessioni e messaggi appariranno qui</div>
          </div>
        ) : notifiche.map((n, i) => {
          const isInvito = n.tipo === 'invito_gruppo'
          const isRichiesta = n.tipo === 'richiesta_utente' || n.tipo === 'risposta_richiesta'

          // FIX: dest corretti — 'home' (non 'oggi'), 'messaggi' rimane ma gestito in HomeAtleta
          const dest = isInvito ? null
            // Richiesta di ingresso a un gruppo: porta nel gruppo, non in
            // "Richieste e segnalazioni" (che è tutt'altra cosa)
            : n.tipo === 'richiesta_gruppo' ? 'gruppo_richieste'
            : n.tipo === 'sessione' ? 'home'
            : n.tipo === 'messaggio' ? 'messaggi'
            : isRichiesta ? 'richieste'
            : n.tipo === 'adesione' ? 'adesioni'
            : null

          const datiNotifica = (() => { try { return JSON.parse(n.dati || '{}') } catch { return {} } })()
          const colore = COLORI[n.tipo] || COLORI.default
          const labelDest = n.tipo === 'richiesta_gruppo' ? 'Vai al gruppo →'
            : n.tipo === 'sessione' ? 'Vai alla home →'
            : n.tipo === 'messaggio' ? 'Vai ai messaggi →'
            : isRichiesta ? 'Vai alle richieste →'
            : n.tipo === 'adesione' ? 'Vai alle adesioni →'
            : null

          return (
            <div key={n.id}
              style={{ padding: '14px 0', borderBottom: i < notifiche.length - 1 ? '1px solid var(--border)' : 'none', opacity: (n.letta && !isInvito) ? 0.65 : 1 }}>
              <div style={{ display: 'flex', gap: 12, cursor: dest ? 'pointer' : 'default' }}
                onClick={() => {
                  if (!dest || !onNavigate) return
                  // Messaggi: apri modal inline invece di navigare
                  if (n.tipo === 'messaggio') {
                    setMessaggioAperto(n)
                    return
                  }
                  onNavigate(dest, datiNotifica.richiesta_id, datiNotifica)
                }}>
                <div style={{ width: 40, height: 40, borderRadius: '50%', flexShrink: 0, background: colore.bg, border: `1px solid ${colore.border}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>
                  {ICONE[n.tipo] || ICONE.default}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                    <div style={{ fontWeight: 600, fontSize: 13, fontFamily: 'Syne' }}>{n.titolo}</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5, flexShrink: 0 }}>
                      {!n.letta && <div style={{ width: 7, height: 7, borderRadius: '50%', background: 'var(--accent)' }} />}
                      {dest && <span style={{ color: 'var(--muted)', fontSize: 14 }}>›</span>}
                    </div>
                  </div>
                  {(n.messaggio || n.testo) && (
                    <div style={{ fontSize: 12, color: 'var(--muted)', marginTop: 3, lineHeight: 1.5 }}>
                      {n.messaggio || n.testo}
                    </div>
                  )}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 4 }}>
                    <span style={{ fontSize: 11, color: 'var(--muted)' }}>{new Date(n.creato_il).toLocaleDateString('it-IT', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</span>
                    {dest && <span style={{ fontSize: 10, fontWeight: 700, color: isRichiesta ? 'var(--accent)' : n.tipo === 'sessione' ? 'var(--accent)' : 'var(--accent2)' }}>{labelDest}</span>}
                  </div>
                </div>
              </div>
              {/* Bottoni accetta/rifiuta per inviti gruppo */}
              {isInvito && (
                <div style={{ display: 'flex', gap: 8, marginTop: 10, paddingLeft: 52 }}>
                  <button
                    onClick={() => rispondiInvito(n, 'accetta')}
                    disabled={rispondendo === n.id}
                    style={{ flex: 1, padding: '8px', borderRadius: 10, border: 'none', background: 'var(--accent)', color: '#000', fontWeight: 700, fontSize: 13, cursor: 'pointer', fontFamily: 'Syne', opacity: rispondendo === n.id ? 0.6 : 1 }}>
                    {rispondendo === n.id ? '...' : '✓ Accetta'}
                  </button>
                  <button
                    onClick={() => rispondiInvito(n, 'rifiuta')}
                    disabled={rispondendo === n.id}
                    style={{ flex: 1, padding: '8px', borderRadius: 10, border: '1px solid rgba(248,113,113,0.4)', background: 'none', color: 'var(--red)', fontWeight: 700, fontSize: 13, cursor: 'pointer', fontFamily: 'Syne', opacity: rispondendo === n.id ? 0.6 : 1 }}>
                    {rispondendo === n.id ? '...' : '✕ Rifiuta'}
                  </button>
                </div>
              )}
            </div>
          )
        })}
      </div>

      {/* Modal messaggio */}
      {messaggioAperto && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 1000,
          background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '20px',
        }} onClick={() => setMessaggioAperto(null)}>
          <div style={{
            background: 'var(--surface)', borderRadius: 20,
            padding: '24px 20px 28px', width: '100%', maxWidth: 430,
            border: '1px solid var(--border)',
          }} onClick={e => e.stopPropagation()}>

            {/* Header */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'rgba(87,184,255,0.15)', border: '1px solid rgba(87,184,255,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>💬</div>
                <div>
                  <div style={{ fontFamily: 'Syne', fontWeight: 700, fontSize: 14 }}>{messaggioAperto.titolo}</div>
                  <div style={{ fontSize: 11, color: 'var(--muted)' }}>
                    {new Date(messaggioAperto.creato_il).toLocaleDateString('it-IT', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
                  </div>
                </div>
              </div>
              <button onClick={() => setMessaggioAperto(null)} style={{ background: 'var(--surface2)', border: 'none', borderRadius: '50%', width: 32, height: 32, fontSize: 16, cursor: 'pointer', color: 'var(--text)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>✕</button>
            </div>
            {/* Testo messaggio */}
            <div style={{ background: 'var(--surface2)', borderRadius: 12, padding: '14px 16px', fontSize: 14, lineHeight: 1.6, color: 'var(--text)', border: '1px solid var(--border)' }}>
              {messaggioAperto.testo || messaggioAperto.messaggio || 'Nessun contenuto'}
            </div>
            <button onClick={() => setMessaggioAperto(null)} className="btn btn-primary" style={{ width: '100%', marginTop: 16 }}>
              Chiudi
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
